import PropTypes from 'prop-types';

import { Box, Button, Grid } from '@mui/material';

import UploadComponent from '../FormField/UploadComponent';

import { SheetJSFT } from './utils';

const DataInputComponent = (props) => {
  const { data, file, onImport, onFileUpload, onImportTitle, handleFile } =
    props;

  const handleChange = (e) => {
    const { files } = e.target;
    if (files && files[0]) handleFile(files[0]);
  };

  const onSubmit = () => {
    if (file && onFileUpload) return onFileUpload(file, data);
    return onImport(data);
  };

  return (
    <Grid container wrap="nowrap" width="100%" mb="2rem">
      <Box flex="1">
        <UploadComponent
          input={{}}
          meta={{}}
          accept={SheetJSFT}
          placeholder={file?.name}
          addItem={handleChange}
        />
      </Box>

      {data && data.length ? (
        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={onSubmit}
          sx={{ marginLeft: '1rem' }}
        >
          {onImportTitle}
        </Button>
      ) : null}
    </Grid>
  );
};
DataInputComponent.defaultProps = {
  onImport: () => {},
  onFileUpload: null,
};
DataInputComponent.propTypes = {
  handleFile: PropTypes.func.isRequired,
  onImport: PropTypes.func,
  onFileUpload: PropTypes.func,
  data: PropTypes.instanceOf(Array).isRequired,
  file: PropTypes.instanceOf(Object),
  onImportTitle: PropTypes.string,
};

export default DataInputComponent;
